module.exports = __webpack_public_path__ + "static/media/theme-landing-5.6d82f28a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/theme-landing-5.jpg
// module id = 363
// module chunks = 0